// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5931b5c","952":"f7caf9d5"}[chunkId] + ".chunk.js";
};